export default {
  'about.title': 'About',
  'about.titleHighlight': 'Me',
  'about.subtitle': '技術を通じて教育とコミュニケーションに革新をもたらす研究者',
  'about.passion.title': '研究への想い',
  'about.passion.p1': '技術領域としてXRや機械学習、IoTなど幅広く興味を持っており、これらの技術を柔軟に組み合わせて研究や開発をしています。',
  'about.passion.p2': '技術を使って教育やコミュニケーション、ゲーミフィケーションで革新を生み出すことに取り組んでいます。大学・業界とらわれず、さまざまな方と共同研究や開発などを積極的に進めて行こうと思っています。',
  'about.passion.p3': '現在は東京大学大学院で博士課程に在籍しながら、株式会社Play Life Studioの代表取締役として、研究成果の社会実装にも取り組んでいます。',
  'about.position.title': '現在のポジション',
  'about.position.utokyo': '東京大学大学院',
  'about.position.utokyoRole': '学際情報学府 博士課程',
  'about.position.utokyoLab': '矢谷研究室 (IIS-Lab)',
  'about.position.playlife': '株式会社Play Life Studio',
  'about.position.playlifeRole': '代表取締役CEO',
  'about.position.nvidia': 'NVIDIA合同会社',
  'about.position.nvidiaRole': 'Senior Solution Architect',
  'about.interests.title': 'Research Interests',
  'about.interests.xr.title': 'XR技術',
  'about.interests.xr.desc': 'VR、AR、MRなどの拡張現実技術を活用した革新的な体験設計',
  'about.interests.hci.title': 'HCI研究',
  'about.interests.hci.desc': 'ヒューマンコンピュータインタフェースの研究と実装',
  'about.interests.edtech.title': 'EdTech',
  'about.interests.edtech.desc': '教育技術とゲーミフィケーションを融合した学習体験',
  'about.interests.gamification.title': 'ゲーミフィケーション',
  'about.interests.gamification.desc': 'ゲーム要素を活用したエンゲージメント向上',
};
